import { Divider as AntDivider, type DividerProps } from 'antd'

export type UiDividerProps = DividerProps

// Wrapper Divider: bọc AntD Divider để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). Pass-through, không thêm hành vi.
export default function UiDivider(props: UiDividerProps) {
  return <AntDivider {...props} />
}
